import React from 'react'

import { AsyncSelect } from '_zari/core'

import * as SocioService from 'services/socio.service'

const Select2SocioTodosInput = ({ id, disabled, onChange }) => {
  const loadSociosSelect = React.useCallback((inputValue, resolve) => {
    SocioService.obtenerSociosTodosxBusquedaAsSelect2({
      busqueda: inputValue
    })
      .then(({ data }) => resolve(data))
      .catch(() => resolve([]))
  }, [])

  return (
    <>
      <AsyncSelect selectId={id} loadOptions={loadSociosSelect} onChange={onChange} />
    </>
  )
}

export default React.memo(Select2SocioTodosInput)
